import { useState, createContext } from "react";
import { api } from "../services/api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt from "jwt-decode";

export const AuthContext = createContext({});

export function AuthContextProvider(props) {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  async function signAdmin(user) {
    setLoading(true);

    try {
      const { data } = await api.post("/sessions", user);

      // Exibe sucesso no login
      toast.success("Login bem-sucedido!", {
        position: toast.POSITION.TOP_RIGHT
      });

      const unscrypted = jwt(data.token);

      // Armazena o token no localStorage e redireciona para o dashboard
      localStorage.setItem("@medusapayments:access_token", data.token);

      localStorage.setItem("@medusapayments:name", unscrypted.emp_razaosocial);

      await navigate("/dashboard");
    } catch (err) {
      // Exibe erro no login
      toast.error("Erro ao fazer login. Verifique suas credenciais.", {
        position: toast.POSITION.TOP_RIGHT
      });
    } finally {
      setLoading(false);
    }
  }

  function logout() {
    // Limpa o token e redireciona para a página de login
    localStorage.removeItem("@medusapayments:access_token");
    navigate("/login");
  }

  return (
    <>
      <ToastContainer />
      <AuthContext.Provider value={{ user, loading, signAdmin, logout }}>
        {props.children}
      </AuthContext.Provider>
    </>
  );
}
